import SettingsShell from "./redesign/SettingsShell";

// The Settings page now renders the redesigned shell. The old tab-based
// implementation has been superseded by `redesign/SettingsShell.jsx`, whose
// panels reuse the existing Setting subcomponents (MyProfile, BusinessProfile,
// Security, Notifications, etc.). We keep this default export so the route
// import in `src/pages/Home/index.jsx` (`import Setting from "./Setting"`)
// continues to work unchanged.
const Setting = () => {
  return <SettingsShell />;
};

export default Setting;
